// src/components/course/CourseLayout.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASELINE } from '../../../../util';

// Import Icons
import { AiOutlineRobot } from 'react-icons/ai';
import { RiMenu4Line } from 'react-icons/ri';
import { IoClose } from 'react-icons/io5';
import { FiArrowLeft, FiBook, FiBookOpen, FiCheckCircle, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

// Import Components
import ProgressSidebar from './ProgressSidebar';
import ProgressItem from './ProgressItem';
import QuizContent from './QuizContent';
import HTMLContent from './HTMLContent';
import TestReview from './TestReview';
import ReviewQuizContent from './ReviewQuizContent';
import AIChat from './AIChat';

const CourseLayout = ({ courseId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courseData, setCourseData] = useState(null);
  const [currentSection, setCurrentSection] = useState(1);
  const [maxUnlockedSection, setMaxUnlockedSection] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [placementTest, setPlacementTest] = useState('');
  const [introReview, setIntroReview] = useState('');
  const [totalTime, setTotalTime] = useState('');
  const [avgTime, setAvgTime] = useState('');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [courseProgress, setCourseProgress] = useState(null);
  const contentRef = useRef(null);

  useEffect(() => {
    // 퀴즈 네비게이션 기능 설정
    const setupQuizNavigation = () => {
      const q1Btn = document.getElementById('q1-btn');
      const q2Btn = document.getElementById('q2-btn');
      const q3Btn = document.getElementById('q3-btn');
      const q4Btn = document.getElementById('q4-btn');
      const q5Btn = document.getElementById('q5-btn');
      const q6Btn = document.getElementById('q6-btn');

      const question1 = document.getElementById('question1');
      const question2 = document.getElementById('question2');
      const question3 = document.getElementById('question3');
      const question4 = document.getElementById('question4');
      const question5 = document.getElementById('question5');
      const question6 = document.getElementById('question6');

      // 각 버튼이 있는지 확인하고 이벤트 리스너 추가
      if (q1Btn && question1) {
        q1Btn.addEventListener('click', function () {
          question1.style.display = 'block';
          if (question2) question2.style.display = 'none';
          if (question3) question3.style.display = 'none';
          if (question4) question4.style.display = 'none';
          if (question5) question5.style.display = 'none';
          if (question6) question6.style.display = 'none';

          q1Btn.classList.add('active');
          if (q2Btn) q2Btn.classList.remove('active');
          if (q3Btn) q3Btn.classList.remove('active');
          if (q4Btn) q4Btn.classList.remove('active');
          if (q5Btn) q5Btn.classList.remove('active');
          if (q6Btn) q6Btn.classList.remove('active');
        });
      }

      if (q2Btn && question2) {
        q2Btn.addEventListener('click', function () {
          if (question1) question1.style.display = 'none';
          question2.style.display = 'block';
          if (question3) question3.style.display = 'none';
          if (question4) question4.style.display = 'none';
          if (question5) question5.style.display = 'none';
          if (question6) question6.style.display = 'none';

          if (q1Btn) q1Btn.classList.remove('active');
          q2Btn.classList.add('active');
          if (q3Btn) q3Btn.classList.remove('active');
          if (q4Btn) q4Btn.classList.remove('active');
          if (q5Btn) q5Btn.classList.remove('active');
          if (q6Btn) q6Btn.classList.remove('active');
        });
      }

      if (q3Btn && question3) {
        q3Btn.addEventListener('click', function () {
          if (question1) question1.style.display = 'none';
          if (question2) question2.style.display = 'none';
          question3.style.display = 'block';
          if (question4) question4.style.display = 'none';
          if (question5) question5.style.display = 'none';
          if (question6) question6.style.display = 'none';

          if (q1Btn) q1Btn.classList.remove('active');
          if (q2Btn) q2Btn.classList.remove('active');
          q3Btn.classList.add('active');
          if (q4Btn) q4Btn.classList.remove('active');
          if (q5Btn) q5Btn.classList.remove('active');
          if (q6Btn) q6Btn.classList.remove('active');
        });
      }

      if (q4Btn && question4) {
        q4Btn.addEventListener('click', function () {
          if (question1) question1.style.display = 'none';
          if (question2) question2.style.display = 'none';
          if (question3) question3.style.display = 'none';
          question4.style.display = 'block';
          if (question5) question5.style.display = 'none';
          if (question6) question6.style.display = 'none';

          if (q1Btn) q1Btn.classList.remove('active');
          if (q2Btn) q2Btn.classList.remove('active');
          if (q3Btn) q3Btn.classList.remove('active');
          q4Btn.classList.add('active');
          if (q5Btn) q5Btn.classList.remove('active');
          if (q6Btn) q6Btn.classList.remove('active');
        });
      }

      if (q5Btn && question5) {
        q5Btn.addEventListener('click', function () {
          if (question1) question1.style.display = 'none';
          if (question2) question2.style.display = 'none';
          if (question3) question3.style.display = 'none';
          if (question4) question4.style.display = 'none';
          question5.style.display = 'block';
          if (question6) question6.style.display = 'none';

          if (q1Btn) q1Btn.classList.remove('active');
          if (q2Btn) q2Btn.classList.remove('active');
          if (q3Btn) q3Btn.classList.remove('active');
          if (q4Btn) q4Btn.classList.remove('active');
          q5Btn.classList.add('active');
          if (q6Btn) q6Btn.classList.remove('active');
        });
      }

      if (q6Btn && question6) {
        q6Btn.addEventListener('click', function () {
          if (question1) question1.style.display = 'none';
          if (question2) question2.style.display = 'none';
          if (question3) question3.style.display = 'none';
          if (question4) question4.style.display = 'none';
          if (question5) question5.style.display = 'none';
          question6.style.display = 'block';

          if (q1Btn) q1Btn.classList.remove('active');
          if (q2Btn) q2Btn.classList.remove('active');
          if (q3Btn) q3Btn.classList.remove('active');
          if (q4Btn) q4Btn.classList.remove('active');
          if (q5Btn) q5Btn.classList.remove('active');
          q6Btn.classList.add('active');
        });
      }
    };

    // 솔루션 토글 기능 정의 - 전역으로 추가
    window.toggleSolutionAlt = (elem) => {
      // 클릭한 요소의 가장 가까운 .solution-container를 찾습니다.
      const container = elem.closest('.solution-container');
      if (!container) {
        console.error('No .solution-container element found.');
        return;
      }

      // 그 안에서 .solution-content 요소를 선택합니다.
      const content = container.querySelector('.solution-content');
      // 토글 버튼 내부의 .solution-button을 찾습니다.
      const button = elem.querySelector('.solution-button');

      if (!content) {
        console.error('No .solution-content element found.');
        return;
      }

      if (content.style.display === 'block') {
        content.style.display = 'none';
        if (button) button.textContent = '+';
      } else {
        content.style.display = 'block';
        if (button) button.textContent = '−';
      }
    };

    // 일반 솔루션 토글 기능 정의
    window.toggleSolution = (elem) => {
      // 가장 가까운 .question 요소 내에서 .question-solution을 찾습니다.
      const questionContainer = elem.closest('.question');
      if (!questionContainer) {
        console.error('No .question element found.');
        return;
      }
      const content = questionContainer.querySelector('.question-solution');
      if (!content) {
        console.error('No .question-solution element found.');
        return;
      }

      if (content.style.display === 'block') {
        content.style.display = 'none';
        elem.textContent = '+';
      } else {
        content.style.display = 'block';
        elem.textContent = '−';
      }
    };

    // 답변 확인 기능 정의
    window.checkAnswers = (btn) => {
      const matchingTable = btn.previousElementSibling;
      if (!matchingTable) {
        console.error('No matching table found.');
        return;
      }

      const inputs = matchingTable.querySelectorAll('.matching-input');
      if (inputs.length === 0) {
        console.error('No .matching-input elements found.');
        return;
      }

      inputs.forEach(input => {
        const correctAnswer = input.getAttribute('data-correct');
        const userAnswer = input.value ? input.value.toUpperCase() : '';

        if (userAnswer === correctAnswer) {
          input.style.backgroundColor = '#34D399';
          input.style.color = '#064E3B';
          input.style.borderColor = '#34D399';
        } else {
          input.style.backgroundColor = '#F87171';
          input.style.color = '#7F1D1D';
          input.style.borderColor = '#F87171';
        }
      });
    };

    // 솔루션 토글 버튼에 이벤트 리스너 추가
    const setupSolutionToggles = () => {
      const solutionToggles = document.querySelectorAll('.solution-toggle');
      solutionToggles.forEach(toggle => {
        // 이미 이벤트가 등록되었는지 확인
        if (!toggle.getAttribute('data-event-attached')) {
          if (toggle.getAttribute('data-solution-type') === 'alt') {
            // onclick 속성 제거하고 이벤트 리스너 추가
            toggle.removeAttribute('onclick');
            toggle.addEventListener('click', function () {
              window.toggleSolutionAlt(this);
            });
          } else {
            toggle.addEventListener('click', function () {
              window.toggleSolution(this);
            });
          }
          toggle.setAttribute('data-event-attached', 'true');
        }
      });
    };

    // 탭 기능 설정
    const setupAllTabs = () => {
      // 기능어 탭 (positive/neutral/negative)
      const setupFunctionWordsTabs = () => {
        const allBtn = document.getElementById('all-btn');
        const positiveBtn = document.getElementById('positive-btn');
        const neutralBtn = document.getElementById('neutral-btn');
        const negativeBtn = document.getElementById('negative-btn');

        const positiveCard = document.getElementById('positive-card');
        const neutralCard = document.getElementById('neutral-card');
        const negativeCard = document.getElementById('negative-card');

        // 모든 요소가 존재하는지 확인
        if (!allBtn || !positiveBtn || !neutralBtn || !negativeBtn ||
          !positiveCard || !neutralCard || !negativeCard) {
          // 요소가 없으면 이 탭 설정을 건너뜁니다
          return;
        }

        // All 탭 클릭 이벤트
        allBtn.addEventListener('click', function () {
          positiveCard.style.display = 'block';
          neutralCard.style.display = 'block';
          negativeCard.style.display = 'block';

          allBtn.classList.add('active');
          positiveBtn.classList.remove('active');
          neutralBtn.classList.remove('active');
          negativeBtn.classList.remove('active');
        });

        // Positive 탭 클릭 이벤트
        positiveBtn.addEventListener('click', function () {
          positiveCard.style.display = 'block';
          neutralCard.style.display = 'none';
          negativeCard.style.display = 'none';

          allBtn.classList.remove('active');
          positiveBtn.classList.add('active');
          neutralBtn.classList.remove('active');
          negativeBtn.classList.remove('active');
        });

        // Neutral 탭 클릭 이벤트
        neutralBtn.addEventListener('click', function () {
          positiveCard.style.display = 'none';
          neutralCard.style.display = 'block';
          negativeCard.style.display = 'none';

          allBtn.classList.remove('active');
          positiveBtn.classList.remove('active');
          neutralBtn.classList.add('active');
          negativeBtn.classList.remove('active');
        });

        // Negative 탭 클릭 이벤트
        negativeBtn.addEventListener('click', function () {
          positiveCard.style.display = 'none';
          neutralCard.style.display = 'none';
          negativeCard.style.display = 'block';

          allBtn.classList.remove('active');
          positiveBtn.classList.remove('active');
          neutralBtn.classList.remove('active');
          negativeBtn.classList.add('active');
        });
      };

      // A/B/C 패턴 탭 설정
      const setupPatternABCTabs = () => {
        const patternABtn = document.getElementById('pattern-a-btn');
        const patternBBtn = document.getElementById('pattern-b-btn');
        const patternCBtn = document.getElementById('pattern-c-btn');

        const patternA = document.getElementById('pattern-a');
        const patternB = document.getElementById('pattern-b');
        const patternC = document.getElementById('pattern-c');

        // 모든 요소가 존재하는지 확인
        if (!patternABtn || !patternBBtn || !patternCBtn ||
          !patternA || !patternB || !patternC) {
          // 요소가 없으면 이 탭 설정을 건너뜁니다
          return;
        }

        // Pattern A 탭 클릭 이벤트
        patternABtn.addEventListener('click', function () {
          patternA.style.display = 'block';
          patternB.style.display = 'none';
          patternC.style.display = 'none';

          patternABtn.classList.add('active');
          patternBBtn.classList.remove('active');
          patternCBtn.classList.remove('active');
        });

        // Pattern B 탭 클릭 이벤트
        patternBBtn.addEventListener('click', function () {
          patternA.style.display = 'none';
          patternB.style.display = 'block';
          patternC.style.display = 'none';

          patternABtn.classList.remove('active');
          patternBBtn.classList.add('active');
          patternCBtn.classList.remove('active');
        });

        // Pattern C 탭 클릭 이벤트
        patternCBtn.addEventListener('click', function () {
          patternA.style.display = 'none';
          patternB.style.display = 'none';
          patternC.style.display = 'block';

          patternABtn.classList.remove('active');
          patternBBtn.classList.remove('active');
          patternCBtn.classList.add('active');
        });
      };

      // D/E/F/G/H/I 패턴 탭 설정
      const setupPatternDEFGHITabs = () => {
        const patternDBtn = document.getElementById('pattern-d-btn');
        const patternEBtn = document.getElementById('pattern-e-btn');
        const patternFBtn = document.getElementById('pattern-f-btn');
        const patternGBtn = document.getElementById('pattern-g-btn');
        const patternHBtn = document.getElementById('pattern-h-btn');
        const patternIBtn = document.getElementById('pattern-i-btn');

        const patternD = document.getElementById('pattern-d');
        const patternE = document.getElementById('pattern-e');
        const patternF = document.getElementById('pattern-f');
        const patternG = document.getElementById('pattern-g');
        const patternH = document.getElementById('pattern-h');
        const patternI = document.getElementById('pattern-i');

        // 모든 요소가 존재하는지 확인
        if (!patternDBtn || !patternEBtn || !patternFBtn || !patternGBtn || !patternHBtn || !patternIBtn ||
          !patternD || !patternE || !patternF || !patternG || !patternH || !patternI) {
          // 요소가 없으면 이 탭 설정을 건너뜁니다
          return;
        }

        // Pattern D 버튼 (Compound Subjects)
        patternDBtn.addEventListener('click', function () {
          patternD.style.display = 'block';
          patternE.style.display = 'none';
          patternF.style.display = 'none';
          patternG.style.display = 'none';
          patternH.style.display = 'none';
          patternI.style.display = 'none';

          patternDBtn.classList.add('active');
          patternEBtn.classList.remove('active');
          patternFBtn.classList.remove('active');
          patternGBtn.classList.remove('active');
          patternHBtn.classList.remove('active');
          patternIBtn.classList.remove('active');
        });

        // Pattern E 버튼 (There is/are)
        patternEBtn.addEventListener('click', function () {
          patternD.style.display = 'none';
          patternE.style.display = 'block';
          patternF.style.display = 'none';
          patternG.style.display = 'none';
          patternH.style.display = 'none';
          patternI.style.display = 'none';

          patternDBtn.classList.remove('active');
          patternEBtn.classList.add('active');
          patternFBtn.classList.remove('active');
          patternGBtn.classList.remove('active');
          patternHBtn.classList.remove('active');
          patternIBtn.classList.remove('active');
        });

        // 나머지 패턴 버튼들에 대한 이벤트 리스너...
        // Pattern F 버튼 (Gerunds)
        patternFBtn.addEventListener('click', function () {
          patternD.style.display = 'none';
          patternE.style.display = 'none';
          patternF.style.display = 'block';
          patternG.style.display = 'none';
          patternH.style.display = 'none';
          patternI.style.display = 'none';

          patternDBtn.classList.remove('active');
          patternEBtn.classList.remove('active');
          patternFBtn.classList.add('active');
          patternGBtn.classList.remove('active');
          patternHBtn.classList.remove('active');
          patternIBtn.classList.remove('active');
        });

        // Pattern G 버튼 (Collective Nouns)
        patternGBtn.addEventListener('click', function () {
          patternD.style.display = 'none';
          patternE.style.display = 'none';
          patternF.style.display = 'none';
          patternG.style.display = 'block';
          patternH.style.display = 'none';
          patternI.style.display = 'none';

          patternDBtn.classList.remove('active');
          patternEBtn.classList.remove('active');
          patternFBtn.classList.remove('active');
          patternGBtn.classList.add('active');
          patternHBtn.classList.remove('active');
          patternIBtn.classList.remove('active');
        });

        // Pattern H 버튼 (That/What)
        patternHBtn.addEventListener('click', function () {
          patternD.style.display = 'none';
          patternE.style.display = 'none';
          patternF.style.display = 'none';
          patternG.style.display = 'none';
          patternH.style.display = 'block';
          patternI.style.display = 'none';

          patternDBtn.classList.remove('active');
          patternEBtn.classList.remove('active');
          patternFBtn.classList.remove('active');
          patternGBtn.classList.remove('active');
          patternHBtn.classList.add('active');
          patternIBtn.classList.remove('active');
        });

        // Pattern I 버튼 (Indefinite Pronouns)
        patternIBtn.addEventListener('click', function () {
          patternD.style.display = 'none';
          patternE.style.display = 'none';
          patternF.style.display = 'none';
          patternG.style.display = 'none';
          patternH.style.display = 'none';
          patternI.style.display = 'block';

          patternDBtn.classList.remove('active');
          patternEBtn.classList.remove('active');
          patternFBtn.classList.remove('active');
          patternGBtn.classList.remove('active');
          patternHBtn.classList.remove('active');
          patternIBtn.classList.add('active');
        });
      };

      // 모든 탭 설정 함수 실행
      setupFunctionWordsTabs();
      setupPatternABCTabs();
      setupPatternDEFGHITabs();
    };

    // 모든 초기화 작업 실행
    setupQuizNavigation();
    setupSolutionToggles();
    setupAllTabs();

    // DOM 변경 감지를 위한 MutationObserver 설정
    const observerOptions = {
      childList: true,
      subtree: true
    };

    // DOM 변경 시 설정 다시 실행
    const observer = new MutationObserver(() => {
      setupSolutionToggles();
      setupQuizNavigation();
      setupAllTabs();
    });

    // document.body에 옵저버 연결
    observer.observe(document.body, observerOptions);

    // 컴포넌트 언마운트 시 옵저버 정리
    return () => {
      observer.disconnect();

      // 전역 변수 정리
      delete window.toggleSolutionAlt;
      delete window.toggleSolution;
      delete window.checkAnswers;
    };
  }, []);

  // Fetch course data when courseId changes
  useEffect(() => {
    const fetchCourseData = async () => {
      if (!courseId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // Fetch all courses from the API
        const response = await axios.get(`${BASELINE}api/review-courses`);

        if (!response.data.success) {
          throw new Error('Failed to fetch course data');
        }

        // Find the specific course by ID (타입 불일치 방지)
        const foundCourse = response.data.courses.find(course => Number(course.id) === Number(courseId));
        console.log("=||=", foundCourse);

        if (!foundCourse) {
          throw new Error(`Course with ID ${courseId} not found`);
        }
        console.log("==response.data==", response.data);
        console.log("=foundCourse=", foundCourse);

        const typeMapping = {
          eng: "English",
          math: "Math"
        };
        const courseType = typeMapping[foundCourse.type] || foundCourse.type;

        // Format the course data to match the expected structure for the component
        const formattedCourseData = {
          courseTitle: foundCourse.name,
          courseid: foundCourse.id,
          sections: foundCourse.lessons.map(lesson => {
            const sanitizedTitle = lesson.title.replace(/\s+/g, '_');
            return {
              id: lesson.id,
              order: lesson.order_index,
              title: lesson.title,
              type: lesson.type || 'lesson', // Default to 'lesson' if type is not specified
              progress: lesson.progress || 0,
              isAIEnabled: lesson.ai_enabled === 1 || lesson.ai_enabled === true,
              contents: {
                description: lesson.description,
                html: `Class_Materials/${courseType}/${foundCourse.name}/${sanitizedTitle}.html`,
                // Other content details based on lesson type
                ...(lesson.type === 'quiz' && { questions: lesson.questions || [] })
              }
            };
          })
        };

        console.log("==", formattedCourseData);
        setCourseData(formattedCourseData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching course data:', error);
        setError(error.message || 'Failed to load course');
        setLoading(false);
      }
    };
    console.log("=start");
    fetchCourseData();
  }, [courseId]);

  useEffect(() => {
    const initializeUserProgress = async () => {
      if (!courseData || !courseData.sections || courseData.sections.length === 0) {
        return;
      }

      // 이미 사용자 진행 상황이 로드되었는지 확인
      const hasProgressData = courseData.sections.some(section => section.userProgressData);
      if (hasProgressData) {
        console.log('Progress data already loaded, skipping initialization');
        return; // 이미 진행 상황이 로드된 경우 다시 로드하지 않음
      }

      // 사용자 ID 가져오기
      const userId = localStorage.getItem('quiz-loggedinuserid') || '1';

      try {
        // 모든 섹션에 대해 사용자 진행 상황 확인 및 초기화
        const updatedSections = await Promise.all(
          courseData.sections.map(async (section) => {
            // 각 섹션(레슨)에 대한 사용자 진행 상황 조회 또는 생성
            const progressData = await fetchOrCreateUserProgress(userId, section.id);

            // 진행 상황이 있으면 섹션 데이터에 통합
            if (progressData) {
              const scrollProgress = progressData.data?.scroll_progress;
              const progress = progressData.status === 'completed' ? 100
                : scrollProgress != null ? scrollProgress
                : progressData.status === 'in_progress' ? 50
                : 0;
              return { ...section, progress, userProgressData: progressData };
            }
            return section;
          })
        );

        setCourseData(prevData => ({ ...prevData, sections: updatedSections }));

        // 가장 높은 진행 상태에 따라 maxUnlockedSection 설정
        const highestUnlockedSection = Math.max(
          1, // 최소 1 섹션은 항상 열려 있음
          ...updatedSections
            .filter(section => section.userProgressData &&
              (section.userProgressData.status === 'completed' ||
                section.userProgressData.status === 'in_progress'))
            .map(section => section.order + 1)
        );

        setMaxUnlockedSection(highestUnlockedSection);
      } catch (error) {
        console.error('Error initializing user progress:', error);
      }
    };

    initializeUserProgress();
  // courseData가 로드된 직후 실행되도록 courseData를 dependency로 사용
  // hasProgressData 가드가 중복 실행을 막아줌
  }, [courseData]);

  const fetchCourseProgress = async () => {
    if (!courseId) return;

    try {
      const userId = localStorage.getItem('quiz-loggedinuserid') || '1'; // 실제 로직으로 대체 필요
      const response = await axios.get(`${BASELINE}api/course-progress?user_id=${userId}&course_id=${courseId}`);

      if (response.data.success) {
        setCourseProgress(response.data.progress);
      }
    } catch (error) {
      console.error('Error fetching course progress:', error);
    }
  };

  // 코스 데이터가 로드되거나 사용자 진행 상황이 업데이트될 때마다 코스 진행률 갱신
  useEffect(() => {
    fetchCourseProgress();
  }, [courseId]);

  const fetchOrCreateUserProgress = async (userId, lessonId) => {
    try {
      // 사용자 진행 상황 조회
      const response = await axios.get(`${BASELINE}api/user-progress?user_id=${userId}&lesson_id=${lessonId}`);
      return response.data.progress;
    } catch (error) {
      console.error('Error fetching user progress:', error);
      return null;
    }
  };

  const updateUserProgress = async (userId, lessonId, status, data) => {
    try {
      const response = await axios.put(`${BASELINE}api/user-progress`, {
        user_id: userId,
        lesson_id: lessonId,
        status,
        data
      });
      return response.data.progress;
    } catch (error) {
      console.error('Error updating user progress:', error);
      return null;
    }
  };

  // Current section data
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const currentSectionData = courseData?.sections?.find(section => section.order === currentSection - 1);

  // Scroll to top when currentSection changes
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [currentSection]);

  // 스크롤 위치 기반 진행률 업데이트
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const sectionId = currentSectionData?.id;
    if (!sectionId) return;

    // DB에서 복원된 값이 있으면 그 값부터 시작 (F5 후에도 후퇴 방지)
    let localProgress = currentSectionData?.progress ?? 0;
    let saveTimer = null;
    let pendingProgress = null; // 마지막으로 저장 안 된 progress 추적

    const doSave = (progress) => {
      const userId = localStorage.getItem('quiz-loggedinuserid') || '1';
      const status = progress >= 100 ? 'completed' : 'in_progress';
      pendingProgress = null;
      return axios.put(`${BASELINE}api/user-progress`, {
        user_id: userId,
        lesson_id: sectionId,
        status,
        data: { scroll_progress: progress, updated_at: new Date().toISOString() }
      }).catch(e => console.error('progress save error', e));
    };

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      const scrollable = scrollHeight - clientHeight;
      if (scrollable <= 0) return;

      const scrollPct = Math.round((scrollTop / scrollable) * 100);
      const newProgress = scrollPct >= 90 ? 100 : scrollPct;

      if (newProgress <= localProgress) return;
      localProgress = newProgress;
      pendingProgress = newProgress;

      setCourseData(prev => {
        if (!prev) return prev;
        const updatedSections = prev.sections.map(s =>
          s.id === sectionId ? { ...s, progress: newProgress } : s
        );
        return { ...prev, sections: updatedSections };
      });

      // 300ms debounce로 DB 저장
      clearTimeout(saveTimer);
      saveTimer = setTimeout(() => doSave(newProgress), 300);
    };

    // F5/탭 닫기 시 sendBeacon으로 즉시 전송
    const handleUnload = () => {
      if (pendingProgress === null) return;
      const userId = localStorage.getItem('quiz-loggedinuserid') || '1';
      const status = pendingProgress >= 100 ? 'completed' : 'in_progress';
      const payload = JSON.stringify({
        user_id: userId,
        lesson_id: sectionId,
        status,
        data: { scroll_progress: pendingProgress }
      });
      try {
        navigator.sendBeacon(
          `${BASELINE}api/user-progress-beacon`,
          new Blob([payload], { type: 'application/json' })
        );
      } catch { /* sendBeacon 미지원 브라우저 무시 */ }
    };

    el.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('beforeunload', handleUnload);
      clearTimeout(saveTimer);
      // 챕터 이동 시 pending 저장 즉시 flush
      if (pendingProgress !== null) {
        doSave(pendingProgress);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSectionData?.id]);

  const updateSectionProgress = async (sectionId) => {
    if (!courseData) return;

    // 해당 섹션 데이터 찾기
    const sectionData = courseData.sections.find(section => section.id === sectionId);
    if (!sectionData) return;

    // 사용자 ID 가져오기
    const userId = localStorage.getItem('quiz-loggedinuserid') || '1'; // 실제 로직으로 대체 필요

    try {
      // 섹션에 대한 진행 상황 업데이트 (in_progress로 설정)
      const progressData = await updateUserProgress(
        userId,
        currentSectionData.id,
        'completed',
        {
          completed_at: new Date().toISOString(),
          section_order: currentSectionData.order
        }
      );

      if (progressData) {
        // 해당 섹션의 진행 상황 데이터 업데이트
        const updatedSections = courseData.sections.map(section => {
          if (section.id === sectionId) {
            return {
              ...section,
              progress: 100, // in_progress는 50%로 표시
              userProgressData: progressData
            };
          }
          return section;
        });

        setCourseData({
          ...courseData,
          sections: updatedSections
        });
      }
    } catch (error) {
      console.error('Error updating section progress:', error);
    }

    await fetchCourseProgress();
  };

  const handleSectionSelect = (sectionNumber) => {
    setCurrentSection(sectionNumber);
  };

  const handleNext = () => {
    if (!courseData || !courseData.sections || courseData.sections.length === 0) return;
    const nextSection = currentSection + 1;
    if (nextSection <= courseData.sections.length) {
      setCurrentSection(nextSection);
    }
  };

  // 섹션 완료 처리 함수 수정
  const handleSectionComplete = async () => {
    if (!currentSectionData) return;

    // 사용자 ID 가져오기
    const userId = localStorage.getItem('quiz-loggedinuserid') || '1'; // 실제 로직으로 대체 필요

    try {
      // 현재 섹션을 'completed'로 업데이트
      const progressData = await updateUserProgress(
        userId,
        currentSectionData.id,
        'completed',
        {
          completed_at: new Date().toISOString(),
          section_order: currentSectionData.order
        }
      );

      if (progressData) {
        // 현재 섹션의 진행 상황 데이터 업데이트
        const updatedSections = courseData.sections.map(section => {
          if (section.id === currentSectionData.id) {
            return {
              ...section,
              progress: 100, // completed는 100%로 표시
              userProgressData: progressData
            };
          }
          return section;
        });

        setCourseData({
          ...courseData,
          sections: updatedSections
        });
      }

      // 다음 섹션 잠금 해제
      setMaxUnlockedSection(prev => Math.max(prev, currentSection + 1));
    } catch (error) {
      console.error('Error completing section:', error);
    }
  };

  const handlePrevious = () => {
    if (currentSection > 1) {
      setCurrentSection(prev => prev - 1);
    }
  };

  const canAccessSection = (sectionId) => {
    return sectionId <= maxUnlockedSection;
  };

  useEffect(() => {
    if (placementTest) {
      setTotalTime(placementTest.totalTime);
      setAvgTime(placementTest.averageTime);
      const wrongProblems = placementTest.questions.filter(q => q.result === false);
      const wrongAnalyses = [];
      processReviewAnalysis(wrongProblems, wrongAnalyses);
    }
  }, [placementTest]);

  const showNavigationButtons = () => {
    if (!courseData || !courseData.sections || courseData.sections.length === 0) {
      return { hasNext: false, hasPrevious: false };
    }

    // Make sure currentSectionData is properly set
    const sectionIndex = currentSection - 1;
    
    // Fix hasNext logic to be more reliable
    const hasNext = sectionIndex < courseData.sections.length - 1;
    const hasPrevious = currentSection > 1;
    
    return { hasNext, hasPrevious };
  };

  // Helper function to extract valid JSON
  function extractValidJSON(text) {
    if (typeof text !== 'string') return null;

    // Trim leading/trailing whitespace
    let raw = text.trim();

    // Normalize the first brace '{'
    let firstBraceIndex = raw.indexOf('{');
    if (firstBraceIndex === -1) {
      raw = '{' + raw;
    } else {
      raw = raw.substring(firstBraceIndex);
    }

    // Normalize the last brace '}'
    let lastBraceIndex = raw.lastIndexOf('}');
    if (lastBraceIndex === -1) {
      raw = raw + '}';
    } else {
      raw = raw.substring(0, lastBraceIndex + 1);
    }

    // Attempt to parse
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return raw;
      } else {
        return null;
      }
    } catch (err) {
      console.error('JSON parse error:', err);
      return null;
    }
  }

  // Function to analyze wrong problems
  const analyzeWrongProblem = async (problemData) => {
    const messagePrompt = `
      You are friendly SAT Tutor who is very smart. 
      Please analyze the following wrong problem and provide a JSON object with the structure below. 
      Your response must be strictly in JSON format.
    
      {
        "problem": "Provide a brief summary of what the question is asking about. (minimum 30tokens)",
        "aiAdvice": "Offer specific advice on what to review and how to improve for this problem exactly. (minimum 30tokens)"
      }

      Return ONLY the JSON object exactly as specified below. Do not include any extra text, explanations, or markdown formatting.
      The JSON object must begin with '{' and end with '}'.
      
      <Wrong problem data> ${JSON.stringify(problemData)} </Wrong problem data>
    `;
    try {
      const payload = { messages: [{ role: "user", content: messagePrompt }] };
      const res = await axios.post(`${BASELINE}askai4`, payload);
      if (res.data && res.data.message) {
        let fixedResponse = extractValidJSON(res.data.message);
        if (!fixedResponse) throw new Error('Could not extract valid JSON');
        const parsed = JSON.parse(fixedResponse);
        parsed.stem = problemData.stem;
        return parsed;
      } else {
        console.error("Unexpected response structure", res.data);
        return null;
      }
    } catch (error) {
      console.error("Error during API call for wrong problem:", error);
      return null;
    }
  };

  // Function to analyze all wrong problems sequentially
  const analyzeAllWrongProblems = async (wrongProblems, wrongAnalyses) => {
    for (let i = 0; i < wrongProblems.length; i++) {
      const analysis = await analyzeWrongProblem(wrongProblems[i]);
      if (analysis) {
        wrongAnalyses.push(analysis);
      }
    }
  };

  // Function for overall review analysis
  const analyzeOverallReview = async (wrongAnalyses) => {
    const overallPrompt = `
      You are a strict reviewer. Please analyze the following test data and provide a review using the exact JSON structure below.
      
      IMPORTANT REQUIREMENTS:
      1. Return ONLY the JSON object. No additional text, explanations, or code formatting is allowed outside of the JSON.
      2. The JSON object must begin with '{' and end with '}'.
      3. Each field must meet the specified word count exactly (if such a constraint is given).
      4. Do not add any disclaimers, bullet points, or other content beyond what is explicitly defined in the structure.
      
      JSON STRUCTURE TO FOLLOW:
      
      {
        "Greeting": "A short greeting or overview of my test results in plain text.",
        "Time Management": {
          "Letter": "A, B, C, or D",
          "Reason": "A short statement (plain text) about how I managed time, without a letter grade."
        },
        "QuestionAccuracy": {
          "Letter": "A, B, C, or D",
          "Reason": "Explain how accurate I was in answering questions."
        },
        "FocusConsistency": {
          "Letter": "A, B, C, or D",
          "Reason": "Describe how well I maintained focus throughout the test and how consistent my performance was."
        },
        "StrategicApproach": {
          "Letter": "A, B, C, or D",
          "Reason": "Discuss my overall strategy for tackling questions, including any test-taking techniques or planning."
        }
      }

      Do not include any extra text or markdown formatting outside the above JSON structure.
      <Test Data> 
      I missed ${wrongAnalyses.length} problem(s) out of 10 questions.
      I spent ${totalTime} seconds total on the test.
      I spent ${avgTime} seconds on average per question.
      </Test Data>
    `;
    try {
      const payload = { messages: [{ role: "user", content: overallPrompt }] };
      const res = await axios.post(`${BASELINE}askai4`, payload);
      if (res.data && res.data.message) {
        let fixedResponse = extractValidJSON(res.data.message);
        if (!fixedResponse) throw new Error('Could not extract valid JSON');
        const parsed = JSON.parse(fixedResponse);
        parsed.WrongProblems = wrongAnalyses;
        setIntroReview(parsed);
      } else {
        console.error("Unexpected response structure", res.data);
      }
    } catch (error) {
      console.error("Error during overall review API call:", error);
    }
  };

  // Process review analysis
  const processReviewAnalysis = async (wrongProblems, wrongAnalyses) => {
    await analyzeAllWrongProblems(wrongProblems, wrongAnalyses);
    await analyzeOverallReview(wrongAnalyses);
  };

  const { hasNext, hasPrevious } = showNavigationButtons();

  // Show loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#eef2f7]">
        <div className="animate-spin rounded-full h-12 w-12 border-2 border-slate-200 border-t-blue-500"></div>
      </div>
    );
  }

  // Show error state
  if (error || !courseData) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#eef2f7]">
        <div className="bg-red-50 p-6 rounded-2xl border border-red-200 shadow-sm max-w-sm w-full mx-4">
          <h2 className="text-base font-bold text-red-700 mb-1">Failed to load course</h2>
          <p className="text-sm text-red-500">{error || 'Something went wrong. Please try again.'}</p>
        </div>
      </div>
    );
  }

  const calculateProgress = () => {
    // 서버에서 계산된 진행률이 있으면 그것을 사용
    if (courseProgress) {
      return courseProgress.progress_percentage;
    }

    // 그렇지 않으면 현재 방식으로 계산 (폴백)
    if (!courseData || !courseData.sections || courseData.sections.length === 0) {
      return 0;
    }

    // 완료된 섹션과 진행 중인 섹션 수 계산
    let completedSections = 0;
    let inProgressSections = 0;

    courseData.sections.forEach(section => {
      if (section.progress === 100) {
        completedSections++;
      } else if (section.progress === 50) {
        inProgressSections++;
      }
    });
 
    // 총 섹션 수
    const totalSections = courseData.sections.length;

    // 진행률 계산 (완료된 섹션은 100%, 진행 중인 섹션은 50%로 계산)
    const progressPercentage = Math.round(
      ((completedSections * 100) + (inProgressSections * 50)) / (totalSections * 100) * 100
    );

    // 최소 3%, 최대 100%로 제한
    return Math.max(3, Math.min(100, progressPercentage));
  };

  return (
    <div className="flex flex-col md:flex-row h-[calc(100vh-64px)] bg-[#eef2f7]">
      {/* Desktop Sidebar */}
      <div
        className={`hidden md:flex flex-col ${isSidebarCollapsed ? 'w-[64px]' : 'w-[240px]'
          } bg-white border-r border-slate-200 transition-all duration-300 ease-in-out shrink-0`}
      >
        {/* Sidebar Header */}
        {!isSidebarCollapsed && (() => {
          const completedCount = courseData.sections.filter(s => s.progress === 100).length;
          const pct = courseData.sections.length
            ? Math.round((completedCount / courseData.sections.length) * 100)
            : 0;
          return (
            <div className="px-4 pt-4 pb-3 border-b border-slate-100">
              <p className="text-xs font-bold text-slate-800 uppercase tracking-widest mb-3">Course Contents</p>
              {/* Progress bar */}
              <div className="flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-500"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="text-[10px] font-semibold text-slate-400 shrink-0">{pct}%</span>
              </div>
              <p className="text-xs text-slate-400 mt-1">{completedCount} / {courseData.sections.length} completed</p>
            </div>
          );
        })()}
        {/* Sidebar Items */}
        <div className="flex-1 overflow-y-auto py-2 scrollbar-thin scrollbar-track-slate-50 scrollbar-thumb-slate-200">
          {courseData.sections.map((section) => (
            <ProgressItem
              key={section.id}
              title={section.title}
              progress={section.progress}
              isAIEnabled={section.isAIEnabled}
              isActive={currentSection === section.order + 1}
              isLocked={false}
              onClick={handleSectionSelect}
              type={section.type}
              isCollapsed={isSidebarCollapsed}
              order={section.order}
            />
          ))}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <ProgressSidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        sections={courseData.sections}
        currentSection={currentSection}
        canAccessSection={canAccessSection}
        onSectionSelect={setCurrentSection}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col h-full overflow-hidden">
        {/* Header */}
        <div className="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-5 shrink-0 shadow-sm">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="md:hidden p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              <RiMenu4Line size={20} />
            </button>
            <button
              onClick={toggleSidebar}
              className="hidden md:flex p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              {isSidebarCollapsed ? <FiChevronRight size={16} /> : <FiChevronLeft size={16} />}
            </button>
            <div className="h-4 w-px bg-slate-200 hidden md:block" />
            <h1 className="text-sm font-bold text-slate-800 truncate max-w-[200px] md:max-w-xs">
              {courseData.courseTitle}
            </h1>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate('/main/sat/courses')}
              className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors border border-slate-200"
            >
              <FiArrowLeft size={13} />
              Back
            </button>
            {hasPrevious && (
              <button
                onClick={handlePrevious}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors border border-slate-200"
              >
                <FiChevronLeft size={13} />
                <span className="hidden md:inline">Previous</span>
              </button>
            )}
            {hasNext && (
              <button
                onClick={handleNext}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-blue-600 hover:bg-blue-500 transition-colors shadow-sm shadow-blue-200"
              >
                <span className="hidden md:inline">Next</span>
                <FiChevronRight size={13} />
              </button>
            )}
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <div
            ref={contentRef}
            className={`flex-1 overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-track-slate-100 scrollbar-thumb-blue-200 bg-white ${currentSectionData?.isAIEnabled ? 'h-[80%]' : 'h-full'}`}
          >
            <div className="max-w-3xl mx-auto px-8 py-10">
              {currentSectionData?.type === 'quiz' ? (
                currentSectionData.contents?.html && (
                  <HTMLContent htmlPath={currentSectionData.contents.html} />
                )
              ) : currentSectionData?.type === 'analysis' ? (
                introReview && <TestReview introReview={introReview} />
              ) : currentSectionData?.type === 'html' ? (
                currentSectionData.contents?.html && (
                  <HTMLContent htmlPath={currentSectionData.contents.html} />
                )
              ) : currentSectionData?.type === 'review_quiz' ? (
                currentSectionData.contents?.html && (
                  <ReviewQuizContent
                    quizData={currentSectionData.contents}
                    htmlPath={currentSectionData.contents.html}
                  />
                )
              ) : (
                <div className="prose prose-slate text-slate-700">
                  {currentSectionData?.contents?.description}
                </div>
              )}
            </div>
          </div>

          {/* AI Chat Area */}
          {currentSectionData?.isAIEnabled && <AIChat />}
        </div>
      </div>
    </div>
  );
};

export default CourseLayout;